/* eslint-disable react/require-default-props */
import React from 'react';
import { useTheme } from '@emotion/react';
import { DropDown, type DropDownProps } from '@/molecules';

type BaseMenuItem = DropDownProps['menuItems'][number];

export type MenuItem = BaseMenuItem & {
  alwaysVisible?: boolean;
  arrow?: boolean;
};

export type CardMenuProps = {
  menuItems?: MenuItem[];
  onMenuItemClick?: DropDownProps['onChange'];
  onMenuOpen?: DropDownProps['onOpen'];
};

/**
 * CardMenu component
 */
export function CardMenu({
  menuItems = [],
  onMenuItemClick = () => {},
  onMenuOpen = () => {},
}: CardMenuProps) {
  const theme = useTheme();
  if (!onMenuItemClick || menuItems.length === 0) {
    return null;
  }

  return (
    <div className="menu">
      <DropDown
        onOpen={onMenuOpen}
        onChange={onMenuItemClick}
        menuItems={menuItems}
        type="dots-horizontal"
        size="small"
        isRebrand={theme.isRebrand}
      />
    </div>
  );
}

export default CardMenu;
